var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLovely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3001 6.74231C17.3001 7.09231 17.2751 7.43398 17.2334 7.75898C16.8501 7.59231 16.4334 7.50065 15.9918 7.50065C14.9751 7.50065 14.0751 7.9923 13.5168 8.7423C12.9501 7.9923 12.0501 7.50065 11.0334 7.50065C9.32508 7.50065 7.94175 8.8923 7.94175 10.6173C7.94175 12.8506 9.12509 14.559 10.4418 15.7173C10.4001 15.7423 10.3584 15.7507 10.3168 15.7673C10.0668 15.859 9.65009 15.859 9.40009 15.7673C7.24175 15.0257 2.41675 11.959 2.41675 6.74231C2.41675 4.44231 4.26674 2.58398 6.55007 2.58398C7.90841 2.58398 9.10841 3.23398 9.85841 4.24231C10.6167 3.23398 11.8167 2.58398 13.1667 2.58398C15.4501 2.58398 17.3001 4.44231 17.3001 6.74231Z",
    stroke: "#197FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0833 10.6167C19.0833 14.5167 15.475 16.8167 13.8583 17.3667C13.6667 17.4333 13.3583 17.4333 13.1666 17.3667C12.475 17.1333 11.4167 16.575 10.4417 15.7167C9.12498 14.5583 7.94165 12.85 7.94165 10.6167C7.94165 8.89166 9.32498 7.5 11.0333 7.5C12.05 7.5 12.95 7.99166 13.5167 8.74166C14.075 7.99166 14.975 7.5 15.9917 7.5C16.4333 7.5 16.85 7.59166 17.2333 7.75833C18.325 8.24166 19.0833 9.33333 19.0833 10.6167Z",
    stroke: "#197FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovely);
export default __webpack_public_path__ + "static/media/lovely.1a905fb73165a9290ebedc08a39f7e00.svg";
export { ForwardRef as ReactComponent };